import * as React from "react";
import { useState } from "react";
import {
  Box,
  Column,
  Columns,
  IconButton,
  Stack,
  TextField,
  Checkbox,
} from "@origin-digital/ods-core";
import { SvgIcon } from "@origin-digital/ods-icons";
import { AccountBlockValues } from "../types";
import BillingAddressDialog from "./BillingAddressDialog";
import { useFormikContext } from "formik";
import FormContext from "src/context/FormContext";
import { generateBillingAddressString } from "../helper";

// interface BillingAddressProps extends IFormProps {
//   isEditing: boolean;
// }

const BillingAddress = () => {
  const [dialogOpen, setDialog] = useState(false);
  const { values, setFieldValue, errors } =
    useFormikContext<AccountBlockValues>();
  const [billingAddressEnabled, setBillingAddressEnabled] = useState(
    values.sameAsConnectionAddress
  );
  const { formState } = React.useContext(FormContext);

  const determineDisplayAddress = () => {
    if (values.sameAsConnectionAddress && formState.address) {
      return formState.address;
    }

    if (generateBillingAddressString(values["billing-address"])) {
      return generateBillingAddressString(values["billing-address"]);
    }
    return "";
  };

  return (
    <>
      <Columns collapseBelow="md">
        <Column width="2/3">
          <Stack space="medium">
            <TextField
              disabled={billingAddressEnabled}
              id="billing-address"
              label="Billing address"
              variant="outlined"
              error={!!errors?.billingAddressString}
              helperText={errors?.billingAddressString}
              value={determineDisplayAddress()}
              endIcon={
                <Box display="flex">
                  <IconButton
                    noIconPadding
                    onClick={() => {
                      setDialog(true);
                    }}
                  >
                    <SvgIcon titleAccess="Edit" color="neutral">
                      <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25ZM20.71 7.04a.996.996 0 0 0 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83Z" />
                    </SvgIcon>
                  </IconButton>
                </Box>
              }
              hideHelperTextSpace
              //helperText="helperText"
            />
            {formState?.siteDetails?.street_number ? (
              <Checkbox
                id="same-as-connection-address"
                label="Same as connection address"
                checked={values.sameAsConnectionAddress}
                onChange={(e) => {
                  setFieldValue("sameAsConnectionAddress", e.target.checked);
                  setBillingAddressEnabled(!billingAddressEnabled);
                  setFieldValue("billing-address", {});
                  setFieldValue("billingAddressString", "");
                }}
              />
            ) : null}
          </Stack>
        </Column>
        <Column width="1/3" />
      </Columns>
      <BillingAddressDialog open={dialogOpen} setDialog={setDialog} />
    </>
  );
};

export default BillingAddress;
